import i18n from '@/i18n.ts'
import { toast } from '@/lib/hooks/useToast.ts'
import { getLicenceBlockContact, getLicenceBlockReason } from '@/lib/licence/licence.ts'

/**
 * The words for a licence refusal (403 + `X-Licence-Block`), or null for any other error.
 * Written on the client per reason, so the message is in the user's language whatever the
 * server's `detail` says, and carries the contact the refusal ships with.
 */
export function licenceBlockMessage(error: unknown): { title: string; description: string } | null {
  const reason = getLicenceBlockReason(error)
  if (!reason) return null
  const contact = getLicenceBlockContact(error)
  const lines = [i18n.t(`licence.block.${reason}`)]
  if (contact?.email) lines.push(i18n.t('licence.contact.email', { email: contact.email }))
  if (contact?.phone) lines.push(i18n.t('licence.contact.phone', { phone: contact.phone }))
  const title =
    reason === 'project_archived'
      ? i18n.t('licence.block.projectArchivedTitle')
      : i18n.t('licence.block.title')
  return { title, description: lines.join(' ') }
}

/** Shows the licence refusal toast; false (and no toast) when the error is not one. */
export function toastLicenceBlock(error: unknown): boolean {
  const message = licenceBlockMessage(error)
  if (!message) return false
  toast({ variant: 'destructive', ...message })
  return true
}
